let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9VUir")).then(() => parcelRequire('iugdv'));